export const INTEGRATION_DATA_KIND = {
  COMPANY: 'Company',
  TEAM: 'Team',
  EMPLOYEE: 'Employee',
};

export const PAGINATED_INTEGRATION_DATA_ITEMS_MIN_LIMIT = 10;
export const PAGINATED_INTEGRATION_DATA_ITEMS_LIMIT = 50;
